module.exports = __webpack_public_path__ + "files/c16b3fb1ec871b5023353f8d36e27b44.png";